// extracted by mini-css-extract-plugin
export default {"tooltip":"CustomSlider_tooltip__cM06l","verticalLine":"CustomSlider_verticalLine__h052Q","sliderMarkLabelWrapper":"CustomSlider_sliderMarkLabelWrapper__ewtZd"};